import { render, staticRenderFns } from "./StaffingFixedDetail.vue?vue&type=template&id=10f49421&"
import script from "./StaffingFixedDetail.vue?vue&type=script&lang=js&"
export * from "./StaffingFixedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports